import type {FooterLink, LanguageValue, WebshopConfigration} from '~/config/types/webshopConfiguration';
import { PgArea, TgArea } from '~/common/types/area';

const agbLink: LanguageValue = {
  de: 'https://www.transgourmet.ch/de/allgemeine-geschaeftsbedingungen',
  fr: 'https://www.transgourmet.ch/fr/conditions-generales-de-vente',
  it: 'https://www.transgourmet.ch/it/condizioni-generali-di-contratto'
};

const helpLinkBgh: LanguageValue = {
  de: 'https://www.transgourmet.ch/faq',
  fr: 'https://www.transgourmet.ch/faq',
  it: 'https://www.transgourmet.ch/faq'
};

const helpLinkAgh: LanguageValue = {
  de: 'https://www.transgourmet.ch/faq',
  fr: 'https://www.transgourmet.ch/faq',
  it: 'https://www.transgourmet.ch/faq'
};

const endOrderTimeLink: LanguageValue = {
  de: 'https://www.transgourmet.ch/de/co/service/bestellschlusszeiten-und-liefertermine-im-webshop',
  fr: 'https://www.transgourmet.ch/fr/co/service/heures-de-clotures-des-commandes-du-magasin-en-ligne',
  it: 'https://www.transgourmet.ch/it/co/servizio/termini-di-ordinazione-nel-webshop'
};

const registrationLink: LanguageValue = {
  de: 'https://www.transgourmet.ch/de/kunde-werden',
  fr: 'https://www.transgourmet.ch/fr/devenir-client',
  it: 'https://www.transgourmet.ch/it/diventare-cliente'
};

const datenschutzLink = {
  de: 'https://www.transgourmet.ch/de/datenschutzerklaerung',
  fr: 'https://www.transgourmet.ch/fr/protection-des-donnees',
  it: 'https://www.transgourmet.ch/it/protezione-dei-dati'
};

const kundencenterFooterLink: FooterLink = {
  icon: 'phone',
  titleKey: '+41 848 000 501',
  urlDe: 'tel:+41848000501',
  urlFr: 'tel:+41848000501',
  urlIt: 'tel:+41848000501',
  highlighted: true
}

export function getLanguageValue(lang: string, value: LanguageValue) {
  switch (lang) {
    case 'de':
      return value.de;
    case 'fr':
      return value.fr;
    case 'it':
      return value.it;
    default:
      return value.de;
  }
}

export const webshopConfig: WebshopConfigration = {
  agbLink,
  helpLinkBgh,
  helpLinkAgh,
  endOrderTimeLink,
  registrationLink,
  datenschutzLink,
  kundencenterFooterLink,
  latestNavigation: [
    {
      titleKey: 'Broschüren & Aktionen',
      area: PgArea,
      urlDe: 'https://www.transgourmet.ch/de/aktionen-broschueren',
      urlFr: 'https://www.transgourmet.ch/fr/actions-brochures',
      urlIt: 'https://www.transgourmet.ch/it/promozioni-opuscoli'
    },
    {
      titleKey: 'Broschüren & Aktionen',
      area: TgArea,
      urlDe: 'https://www.transgourmet.ch/de/aktionen-broschueren',
      urlFr: 'https://www.transgourmet.ch/fr/actions-brochures',
      urlIt: 'https://www.transgourmet.ch/it/promozioni-opuscoli'
    },
    {
      titleKey: 'Vorverkäufe',
      urlDe: 'https://transgourmet.ch/vorverkauf',
      urlFr: 'https://transgourmet.ch/prevente',
      urlIt: 'https://www.transgourmet.ch/prevendita'
    }
  ],
  ownBrands: [
    {
      titleKey: 'Economy',
      area: TgArea,
      urlDe: `/de/${TgArea.toLowerCase()}/catalog?page=0&brands=1`,
      urlFr: `/fr/${TgArea.toLowerCase()}/catalog?page=0&brands=1`,
      urlIt: `/it/${TgArea.toLowerCase()}/catalog?page=0&brands=1`
    },
    {
      titleKey: 'Economy',
      area: PgArea,
      urlDe: `/de/${PgArea.toLowerCase()}/catalog?page=0&brands=1`,
      urlFr: `/fr/${PgArea.toLowerCase()}/catalog?page=0&brands=1`,
      urlIt: `/it/${PgArea.toLowerCase()}/catalog?page=0&brands=1`
    },
    {
      titleKey: 'Natura',
      area: TgArea,
      urlDe: `/de/${TgArea.toLowerCase()}/catalog?page=0&brands=3687`,
      urlFr: `/fr/${TgArea.toLowerCase()}/catalog?page=0&brands=3687`,
      urlIt: `/it/${TgArea.toLowerCase()}/catalog?page=0&brands=3687`
    },
    {
      titleKey: 'Natura',
      area: PgArea,
      urlDe: `/de/${PgArea.toLowerCase()}/catalog?page=0&brands=3687`,
      urlFr: `/fr/${PgArea.toLowerCase()}/catalog?page=0&brands=3687`,
      urlIt: `/it/${PgArea.toLowerCase()}/catalog?page=0&brands=3687`
    },
    {
      titleKey: 'Origine',
      area: TgArea,
      urlDe: `/de/${TgArea.toLowerCase()}/catalog?page=0&brands=42`,
      urlFr: `/fr/${TgArea.toLowerCase()}/catalog?page=0&brands=42`,
      urlIt: `/it/${TgArea.toLowerCase()}/catalog?page=0&brands=42`
    },
    {
      titleKey: 'Origine',
      area: PgArea,
      urlDe: `/de/${PgArea.toLowerCase()}/catalog?page=0&brands=42`,
      urlFr: `/fr/${PgArea.toLowerCase()}/catalog?page=0&brands=42`,
      urlIt: `/it/${PgArea.toLowerCase()}/catalog?page=0&brands=42`
    },
    {
      titleKey: 'Premium',
      area: TgArea,
      urlDe: `/de/${TgArea.toLowerCase()}/catalog?page=0&brands=33`,
      urlFr: `/fr/${TgArea.toLowerCase()}/catalog?page=0&brands=33`,
      urlIt: `/it/${TgArea.toLowerCase()}/catalog?page=0&brands=33`
    },
    {
      titleKey: 'Premium',
      area: PgArea,
      urlDe: `/de/${PgArea.toLowerCase()}/catalog?page=0&brands=33`,
      urlFr: `/fr/${PgArea.toLowerCase()}/catalog?page=0&brands=33`,
      urlIt: `/it/${PgArea.toLowerCase()}/catalog?page=0&brands=33`
    },
    {
      titleKey: 'Quality',
      area: TgArea,
      urlDe: `/de/${TgArea.toLowerCase()}/catalog?page=0&brands=22`,
      urlFr: `/fr/${TgArea.toLowerCase()}/catalog?page=0&brands=22`,
      urlIt: `/it/${TgArea.toLowerCase()}/catalog?page=0&brands=22`
    },
    {
      titleKey: 'Quality',
      area: PgArea,
      urlDe: `/de/${PgArea.toLowerCase()}/catalog?page=0&brands=22`,
      urlFr: `/fr/${PgArea.toLowerCase()}/catalog?page=0&brands=22`,
      urlIt: `/it/${PgArea.toLowerCase()}/catalog?page=0&brands=22`
    }
  ],
  footer: {
    segments: [
      {
        titleKey: 'Hilfe & Kontakt',
        descriptionKey: 'Bei Fragen stehen wir Ihnen gerne zur Verfügung:',
        links: [
          kundencenterFooterLink,
          {
            icon: 'mail',
            titleKey: 'kundencenter@transgourmet.ch',
            urlDe: 'mailto:kundencenter@transgourmet.ch',
            urlFr: 'mailto:serviceclients@transgourmet.ch',
            urlIt: 'mailto:servizioclienti@transgourmet.ch',
            highlighted: true
          },
          {
            titleKey: 'Öffnungszeiten Kundencenter',
            urlDe: 'https://www.transgourmet.ch/kundencenter',
            urlFr: 'https://www.transgourmet.ch/serviceclients',
            urlIt: 'https://www.transgourmet.ch/servizioclienti'
          },
          {
            titleKey: 'Hilfe',
            urlDe: helpLinkBgh.de,
            urlFr: helpLinkBgh.fr,
            urlIt: helpLinkBgh.it
          },
          {
            titleKey: 'Team',
            area: TgArea,
            urlDe: 'https://www.transgourmet.ch/team',
            urlFr: 'https://www.transgourmet.ch/team',
            urlIt: 'https://www.transgourmet.ch/team'
          },
          {
            titleKey: 'Märkte',
            area: PgArea,
            urlDe: 'https://www.transgourmet.ch/de/pg/maerkte',
            urlFr: 'https://www.transgourmet.ch/fr/marches',
            urlIt: 'https://www.transgourmet.ch/it/pg/mercati'
          }
        ]
      },
      {
        titleKey: 'Unternehmen',
        links: [
          {
            titleKey: 'Über uns',
            urlDe: 'https://www.transgourmet.ch/ueber-uns',
            urlFr: 'https://www.transgourmet.ch/qui-sommes-nous',
            urlIt: 'https://www.transgourmet.ch/chi-siamo'
          },
          {
            titleKey: 'Karriere',
            urlDe: 'https://www.transgourmet.ch/karriere',
            urlFr: 'https://www.transgourmet.ch/carriere',
            urlIt: 'https://www.transgourmet.ch/carriera'
          },
          {
            titleKey: 'Lernende',
            urlDe: 'https://www.transgourmet.ch/lernende',
            urlFr: 'https://www.transgourmet.ch/apprentissage',
            urlIt: 'https://www.transgourmet.ch/apprendisti'
          },
          {
            titleKey: 'Nachhaltigkeit',
            urlDe: 'https://www.transgourmet.ch/nachhaltigkeit',
            urlFr: 'https://www.transgourmet.ch/durabilite',
            urlIt: 'https://www.transgourmet.ch/sostenibilita'
          },
          {
            titleKey: 'Sponsoring',
            urlDe: 'https://www.transgourmet.ch/sponsoring',
            urlFr: 'https://www.transgourmet.ch/sponsoring',
            urlIt: 'https://www.transgourmet.ch/sponsoring'
          },
          {
            titleKey: 'Medien',
            urlDe: 'https://www.transgourmet.ch/media',
            urlFr: 'https://www.transgourmet.ch/media',
            urlIt: 'https://www.transgourmet.ch/media'
          }
        ]
      },
      {
        titleKey: 'Services',
        links: [
          {
            titleKey: 'Kunde werden',
            urlDe: registrationLink.de,
            urlFr: registrationLink.fr,
            urlIt: registrationLink.it
          },
          {
            titleKey: 'Märkte',
            urlDe: 'https://www.transgourmet.ch/maerkte',
            urlFr: 'https://www.transgourmet.ch/marches',
            urlIt: 'https://www.transgourmet.ch/mercati'
          },
          {
            titleKey: 'Kundenportal',
            urlDe: 'https://portal.transgourmet.ch/',
            urlFr: 'https://portal.transgourmet.ch/',
            urlIt: 'https://portal.transgourmet.ch/'
          },
          {
            titleKey: 'Rezepte',
            urlDe: 'https://cook.transgourmet.ch/',
            urlFr: 'https://cook.transgourmet.ch/',
            urlIt: 'https://cook.transgourmet.ch/'
          },
          {
            titleKey: 'Newsletter Anmeldung',
            urlDe: 'https://www.transgourmet.ch/newsletter',
            urlFr: 'https://www.transgourmet.ch/newsletter',
            urlIt: 'https://www.transgourmet.ch/newsletter'
          }
        ]
      }
    ],
    legal: [
      {
        titleKey: 'Impressum',
        urlDe: 'https://www.transgourmet.ch/de/impressum',
        urlFr: 'https://www.transgourmet.ch/fr/impressum',
        urlIt: 'https://www.transgourmet.ch/it/impressum'
      },
      {
        titleKey: 'AGB',
        urlDe: agbLink.de,
        urlFr: agbLink.fr,
        urlIt: agbLink.it
      },
      {
        titleKey: 'Datenschutz',
        urlDe: datenschutzLink.de,
        urlFr: datenschutzLink.fr,
        urlIt: datenschutzLink.it
      }
    ],
    social: [
      {
        icon: 'facebook',
        titleKey: 'Facebook',
        url: 'https://www.facebook.com/transgourmetprodega'
      },
      {
        icon: 'instagram',
        titleKey: 'Instagram',
        url: 'https://www.instagram.com/transgourmetprodega/'
      },
      {
        icon: 'youtube',
        titleKey: 'YouTube',
        url: 'https://www.youtube.com/channel/UCvg-M39EldUDCnaEmHPNFvQ'
      },
      {
        icon: 'linkedin',
        titleKey: 'LinkedIn',
        url: 'https://www.linkedin.com/company/transgourmet-prodega-schweiz/posts/?feedView=all'
      },
      {
        icon: 'whatsapp',
        titleKey: 'WhatsApp',
        url: 'https://www.transgourmet.ch/whatsapp'
      }
    ]
  }
};
